import { render } from "./ComponentSidebar.vue?vue&type=template&id=34e96115&scoped=true"
import script from "./ComponentSidebar.vue?vue&type=script&lang=js"
export * from "./ComponentSidebar.vue?vue&type=script&lang=js"

import "./ComponentSidebar.vue?vue&type=style&index=0&id=34e96115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e96115"]])

export default __exports__